<template>
        <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="6">
                        Periodos de Medición
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Crear nuevo
                        </v-btn>
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-data-table
                        :headers="headers"
                        :items="periodos"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :items-per-page="10"
                        dense
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                    >
                    <template v-slot:item="{ item }">
                        <tr v-if="item.estadosId === 1">
                            <td>{{ item.id }}</td>
                            <td class="text-right">{{ item.anioMedicion }}</td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>




    <!-- Inicio:: Dialog para mostrar los datos de la region-->
    <v-dialog
        v-model="dialog"
        max-width="600px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-account-question-outline</v-icon>
                </v-btn>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosPeriodo.anioMedicion"
                                label="Año de medición"
                                maxlength="4"
                                :rules="[
                                    required(
                                        'Año de medición'
                                    ),
                                    minLength('Año medición', 4),
                                    maxLength('Año medición', 4),
                                    minNumber('Año medición', 2018),
                                    maxNumber('Año medición', 2050),
                                ]"
                                v-mask="'####'"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la region-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_PERIODOS, OBTENER_PERIODO, REGISTRAR_PERIODO, ACTUALIZAR_PERIODO } from "@/core/services/store/catalogos/periodomedicion.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

export default {
    name: "Adminperiodos",
    components: {
        SnackAlert,
        DialogLoader
    },
    data() {
        return {
            validForm:false,
            itemName : "periodos",
            dialog: false,
            modalTitle: 'Registrar Periodo',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Periodo',
            accion: 1,
            periodos: [],
            switchItemEstado: true,
            datosPeriodo: {
                id: 0,
                anioMedicion: '',
                usuarioCreacion: 'admin',
                fechaCreacion: '2021-07-23',
                usuarioActaulizacion: 'admin',
                fechaActualizacion: '2021-07-23',
                estadosId: 1
            },
            
            tableLoading: false,
            ...validations
        } 
    }, 
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Periodo';
            this.btnRegistroText='Registrar Periodo';
            this.dialog=true;
        },

        resetForm(){
            //this.$refs.form.reset();
             this.datosPeriodo= {
                id: 0,
                anioMedicion: '',
                usuarioCreacion: 'admin',
                fechaCreacion: '2021-07-23',
                usuarioActaulizacion: 'admin',
                fechaActualizacion: '2021-07-23',
                estadosId: 1
            };
            this.switchItemEstado=true;
        },

        //!Obtener los periodos para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    this.tableLoading =false;
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosPeriodo.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Periodo';
            this.btnRegistroText='Actualizar Periodo';

            this.$store
                .dispatch(OBTENER_PERIODO, Id)
                .then(res => {
                    if(res.status===200){
                        this.datosPeriodo = this.$store.state.periodomedicion.periodo;
                        this.datosPeriodo.anioMedicion = String(this.$store.state.periodomedicion.periodo.anioMedicion);
                        this.datosPeriodo.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.dialog = true;
                    } else {
                         this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoaderVisible = false;
                })
                .catch(() => {
                    this.dialogLoaderVisible = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                });
        },

        registrarItem(){
            //console.log(this.accion)
            this.btnRegistroLoading=true;
            this.switchItemEstado ? this.datosPeriodo.estadosId = 1 : this.datosPeriodo.estadosId = 2;
            if(this.accion===1){
                this.datosPeriodo.id = 0;
                this.$store
                    .dispatch(REGISTRAR_PERIODO, this.datosPeriodo)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(() => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_PERIODO, this.datosPeriodo)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Catalogos" },
            { title: "Periodos Medición" }
        ]);
    },

    created(){
        this.obtnenerItems();
    },

    
    computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Año de medición",
                    value: "anioMedicion"
                },
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }

    
}
</script>
<style lang="">
    
</style>